<template>
    <b-row>
        <b-col sm="12">
            <b-card>
                <b-row class="pt-2">
                    <b-col sm="12">
                        <table class="table table-bordered companyList">
                            <thead>
                                <tr>
                                    <th scope="col">총 주문건수</th>
                                    <th scope="col">입금대기</th>
                                    <th scope="col">결재완료</th>
                                    <th scope="col">주문취소</th>
                                    <th scope="col">결재완료 금액</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ orderStatus.totalOrderCnt | numberComma }}</td>
                                    <td>{{ orderStatus.depositCnt | numberComma }}</td>
                                    <td>{{ orderStatus.paymentCnt | numberComma }}</td>
                                    <td>{{ orderStatus.orderCancelCnt | numberComma }}</td>
                                    <td>{{ orderStatus.paymentPrice | numberComma }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-table outlined :fields="fields" 
                                :items="items" 
                                :busy="items == 0"
                                :current-page="currentPage" 
                                :per-page="perPage">
                            <div slot="table-busy" class="text-center my-2">
                                <strong>데이터가 없습니다.</strong>
                            </div>
                            <template slot="user_name" slot-scope="row">
                                {{ (row.item.orderer_name !== null && row.item.orderer_name !== '') ? row.item.orderer_name : row.item.user_name }}({{ row.item.user_id }})
                            </template>
                            <template slot="price" slot-scope="row">
                                {{ row.item.price | numberComma }}
                            </template>
                            <template slot="dc_price" slot-scope="row">
                                {{ row.item.dc_price | numberComma }}
                            </template>
                            <template slot="amount" slot-scope="row">
                                {{ row.item.amount | numberComma }}
                            </template>
                        </b-table>
                    </b-col>
                    <b-col sm="12">
                        <b-pagination v-model="currentPage" :totalRows="totalRows" :per-page="perPage"
                            align="center"></b-pagination>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
export default {
    name: "userCompanyList",
    props: {
        userId: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            fields: [
                  {'order_code': {'label': '주문번호', thClass: 'thClass_w08', tdClass: 'textAlignCenter'}}
                , {'p_name': {'label': '상품명', thClass: 'thClass_w20', tdClass: 'tdClass'}}
                , {'user_name': {'label': '담당자 이름(아이디)', thClass: 'thClass_w15', tdClass: 'textAlignCenter'}}
                , {'order_date': {'label': '주문일시', thClass: 'thClass_w12', tdClass: 'textAlignCenter'}}
                , {'pay_type_name': {'label': '결제방식', thClass: 'thClass_w08', tdClass: 'textAlignCenter'}}
                , {'price': {'label': '주문금액', thClass: 'thClass_w08', tdClass: 'textAlignCenter'}}
                , {'dc_price': {'label': '할인금액', thClass: 'thClass_w08', tdClass: 'textAlignCenter'}}
                , {'amount': {'label': '결제금액', thClass: 'thClass_w08', tdClass: 'textAlignCenter'}}
                , {'status_name': {'label': '주문상태', thClass: 'thClass_w08', tdClass: 'textAlignCenter'}}
            ],

            orderStatus: {},
        }
    },
    watch: {
        userId: function (value, oldValue) {
            this.findCompanyOrderList();
        },
    },
    methods: {
        findCompanyOrderList() {
            var token = sessionStorage.getItem("myToken");

            this.$http.get('/api/select/userCompanyList?access_token=' + token + '&user_id=' + this.userId)
                .then((result) => {
                    const { data } = result;
                    this.items = data;
                    // console.log(this.items.length);
                    this.totalRows = this.items.length;

                    let _orderStatus = {
                        totalOrderCnt: 0,
                        depositCnt: 0,
                        paymentCnt: 0,
                        orderCancelCnt: 0,
                        paymentPrice: 0,
                    };

                    _orderStatus.totalOrderCnt = this.items.length;
                    data.forEach(function (el, idx, arr) {
                        const { status, price, amount } = el;
                        if (status === 'ORDER_STATUS_TYPE_1') {
                            _orderStatus.depositCnt += 1;
                        } else if (status === 'ORDER_STATUS_TYPE_3') {
                            _orderStatus.paymentCnt += 1;
                            _orderStatus.paymentPrice += parseInt(price);
                        } else if (status === 'ORDER_STATUS_TYPE_4') {
                            _orderStatus.orderCancelCnt += 1;
                        }
                    });

                    this.orderStatus = _orderStatus;
                })
        }
    }
}
</script>
<style lang="css" scoped>
.companyList thead tr th {
    background: #dcdcdc;
    text-align: center;
}
.companyList tbody tr td {
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/user/userDetail/component/tabs/company/UserCompanyList.vue